import React from 'react';
import { Menu } from '@uncinc/react-drupal-core';
import { useDispatch } from 'react-redux';
import { CoreLink } from '../../../components';

import { hideNavMenu } from '../../../actions/UI';
import { MENU_OTHER, MENU_OTHER_KP } from '../../../config/constants';

import './style.scss';

const FooterKnowledgePlatformMenu = ({ domainKp }) => {
  const dispatch = useDispatch();

  return (
    <div className="FooterKnowledgePlatformMenu">
      <Menu id={domainKp ? MENU_OTHER_KP : MENU_OTHER}>
        {(items) => {
          return (
            <div className="FooterSecondaryMenu__items">
              {items.map((item) => {
                const attrs = item.getIn(['link', 'options', 'attributes'], new Map());
                const href = item.getIn(['link', 'url'], '');
                const title = item.getIn(['link', 'title'], 'Untitled');
                return (
                  <h4 key={`menu--main--menu-item-${title}:${href}`} className="menu--main--menu-item">
                    <CoreLink
                      to={href}
                      target={attrs.get('target')}
                      onClick={() => { dispatch(hideNavMenu()); }}
                    >
                      {title}
                    </CoreLink>
                  </h4>
                );

              })}
            </div>
          );
        }}
      </Menu>
    </div>
  );
};

export default FooterKnowledgePlatformMenu;
